import React, { Component } from 'react';
import history from './history'
import { withRouter, Link } from 'react-router-dom'
import * as Scales from './scales'
import * as Session from './session'
import * as Questions from './questions'


class TestPage extends Component {

    constructor(props) {
        super(props)
        console.log(props)
        let data = TestPage.loadDataForState(props)
        console.log({data})
        this.state = {
            sector: data.sector,
            section: data.section || {},
            subSection: data.subSection || {},
            stage: data.stage || {},
            scaleItems: Scales.Options
        }
    }

    static loadDataForState(props = {}){
        let { sectorId, sectionOffset, subSectionOffset, stageOffset } = props.match.params
        Session.updateSectorIfRequired(sectorId)
        let sector = Session.currentSession.responses
        let section = sector.sections[sectionOffset]
        let subSection = section.subSections? section.subSections[subSectionOffset] : undefined
        let stage = subSection? 
            subSection.stages[stageOffset] 
            : section.stages[stageOffset]

        return {
            sector: sector || {},
            section: section || {},
            subSection: subSection || {},
            stage: stage || {},
        }
    }

    componentWillReceiveProps(nextProps){
        let data = TestPage.loadDataForState(nextProps)
        // console.log({nextProps}, {data})
        this.setState({
            sector: data.sector || {},
            section: data.section || {},
            subSection: data.subSection || {},
            stage: data.stage || {},
            scaleItems: Scales.Options
        })
    }

    nextUrl(){
        let { sectorId, sectionOffset, subSectionOffset, stageOffset } = this.props.match.params
        let currentOffsets = Questions.parseOffsets({ sectionOffset, subSectionOffset, stageOffset } )
        let nextOffsets = Questions.nextStage(this.state.sector, currentOffsets)
        if (nextOffsets) return `/sector/${sectorId}/section/${nextOffsets.sectionOffset}/subsection/${nextOffsets.subSectionOffset}/stage/${nextOffsets.stageOffset}`
        else return '/report'  
    }

    // onNext(){
    //     let { sectionOffset, subSectionOffset, stageOffset } = this.props.match.params
    //     this.props.history.push(`/section/${parseInt(sectionOffset)}/subsection/${parseInt(subSectionOffset)}/stage/${parseInt(stageOffset) + 1}`)
    // }

    tryGoingToNextPage(){
        let nextUrl = this.nextUrl()
        if (Questions.allQuestionsInStageAreAnswered(this.state.stage)) {
            this.props.history.push(nextUrl)
        } else {
            alert(`Falta a responder a pelo menos uma das questões`)
        }
    }


    onResponseChange(question, questionOffset, value) {
        // updates Session object
        question.response = value 
        // calculate score for level of the tree
        Questions.scoreTree(Session.currentSession.responses, Scales.Options)
        console.log(Session.currentSession.responses) 
        // update UI state
        let stage = {...this.state.stage }
        stage.questions[questionOffset].response = value
        this.setState({
            stage
        })
    }

    render(){
        return (
            <div>
                <PageTitle 
                    style={ { marginBottom: '1em' } }
                    section={this.state.section}
                    subSection={this.state.subSection}
                    stage={this.state.stage}
                    />
                <QuestionTable 
                    questions={this.state.stage.questions}
                    scaleItems={this.state.scaleItems}
                    onChange={this.onResponseChange.bind(this) }
                    />
                <div className="clearfix">
                    <button className="btn btn-primary float-right" onClick={this.tryGoingToNextPage.bind(this)}>
                        Avançar
                    </button>
                </div>
            </div>
        )
    }


}

export default withRouter(TestPage)


const PageTitle = (props) => (
    <div style={props.style}>
        {props.section.title}
        {
            props.subSection.title &&
                <span> &mdash; {props.subSection.title}</span>
        }
        {
            props.stage.title &&
                <span> &mdash; {props.stage.title}</span>
        }
    </div>
)

const QuestionTable = (props) => (
    <table className="table">
        <tbody>
            {
                props.questions.map( (question, questionOffset) => {
                    return [
                        <QuestionRow 
                            key={`question-${questionOffset}`}
                            number={questionOffset + 1} 
                            question={question}/>
                            ,
                        <ScaleRow 
                            key={`scale-${questionOffset}`}
                            group={questionOffset} 
                            scaleItems={props.scaleItems}
                            scaleValue={question.response}
                            onChange={props.onChange.bind(this, question, questionOffset)}
                            />
                    ]
                }) 
            }
        </tbody>
    </table>
)


const QuestionRow = (props) => (
    <tr>
        <td colSpan="1000" className="bg-light">
            {props.number}
            &nbsp;
            -
            &nbsp;
            {props.question.title}
        </td>
    </tr>
)


const ScaleRow = (props) => (
    <tr>
        {
            props.scaleItems.map( (item, scaleOffset) => 
                <ScaleItem 
                    key={scaleOffset} 
                    group={props.group} 
                    item={item}
                    checked={item.value === props.scaleValue} 
                    onChange={props.onChange.bind(this)}
                        />
            )
        }
    </tr>
)

const ScaleItem = (props) => (
    <td className="text-center">
        {props.item.label}
        <br/>
        <RadioBox
            group={props.group}
            value={props.item.value}
            checked={props.checked}
            onChange={props.onChange.bind(this, props.item.value)}
            />
        <div style={ { marginBottom: '2em' } }>
        </div>
    </td>
)


const RadioBox = (props) => (
    <input 
        type="radio"
        name={props.group}
        value={props.value}
        checked={props.checked}
        onChange={ (event) => props.onChange(event.target.checked)}
        />
)


// WEBPACK FOOTER //
// ./src/TestPage.jsx